
export default {
  placesCarousel: {
    'layer': 'Réteg',
    'lat': 'Szél.',
    'lon': 'Hossz.',
    'notAvailable': 'Nem elérhető',
    'placeDetails': 'Hely adatai',
    'next': 'Következő blokk',
    'prev': 'Előző blokk',
    'directionsTo': 'Útvonalak ide:',
    'distance': 'Távolság',
    'distanceFromLocationMarkedOnTheMap': 'Hozzávetőleges távolság a térképen jelölt helytől',
    'selectPlace': 'Kiválasztás'
  }
}
